var map = {
	"../pages/article/article.module": [
		848,
		71
	],
	"../pages/bankcard-update-add/bankcard-update-add.module": [
		849,
		70
	],
	"../pages/bankcards/bankcards.module": [
		850,
		11
	],
	"../pages/baoxian-receive/baoxian-receive.module": [
		851,
		69
	],
	"../pages/bus-stop/bus-stop.module": [
		852,
		68
	],
	"../pages/busscan-detail/busscan-detail.module": [
		853,
		24
	],
	"../pages/busscan-home/busscan-home.module": [
		854,
		0
	],
	"../pages/busscan-recharge-list/busscan-recharge-list.module": [
		855,
		14
	],
	"../pages/busscan-recharge/busscan-recharge.module": [
		857,
		23
	],
	"../pages/busscan-refund/busscan-refund.module": [
		856,
		13
	],
	"../pages/busscan-ridebus-list/busscan-ridebus-list.module": [
		858,
		12
	],
	"../pages/chartered-detail/chartered-detail.module": [
		859,
		67
	],
	"../pages/chartered-home/chartered-home.module": [
		860,
		7
	],
	"../pages/chartered-order-detail/chartered-order-detail.module": [
		861,
		66
	],
	"../pages/chartered-order-list/chartered-order-list.module": [
		862,
		65
	],
	"../pages/chartered-place-order/chartered-place-order.module": [
		863,
		64
	],
	"../pages/chartered-place-prepare/chartered-place-prepare.module": [
		864,
		63
	],
	"../pages/choose-bao-xian/choose-bao-xian.module": [
		865,
		62
	],
	"../pages/coupon-center/coupon-center.module": [
		866,
		61
	],
	"../pages/create-or-update-passenger/create-or-update-passenger.module": [
		867,
		60
	],
	"../pages/for-get-password/for-get-password.module": [
		868,
		17
	],
	"../pages/help-center-detail/help-center-detail.module": [
		869,
		59
	],
	"../pages/help-center/help-center.module": [
		870,
		58
	],
	"../pages/home-tourism/home-tourism.module": [
		871,
		6
	],
	"../pages/home/home.module": [
		872,
		2
	],
	"../pages/invoice-home/invoice-home.module": [
		873,
		57
	],
	"../pages/invoice-order-detail/invoice-order-detail.module": [
		874,
		56
	],
	"../pages/invoice-order-list/invoice-order-list.module": [
		875,
		55
	],
	"../pages/login/login-background-slider/login-background-slider.module": [
		876,
		54
	],
	"../pages/login/login-slider/login-slider.module": [
		877,
		53
	],
	"../pages/login/login.module": [
		878,
		52
	],
	"../pages/my-passengerlist/my-passengerlist.module": [
		879,
		51
	],
	"../pages/my-point/my-point.module": [
		880,
		50
	],
	"../pages/my-suggest-add/my-suggest-add.module": [
		881,
		49
	],
	"../pages/my-suggest/my-suggest.module": [
		882,
		48
	],
	"../pages/news-center/news-center.module": [
		883,
		47
	],
	"../pages/news-detail/news-detail.module": [
		884,
		46
	],
	"../pages/options/options.module": [
		885,
		45
	],
	"../pages/order-catalog/order-catalog.module": [
		886,
		44
	],
	"../pages/order-detail/order-detail.module": [
		887,
		43
	],
	"../pages/order-refun-request/order-refun-request.module": [
		888,
		42
	],
	"../pages/order-sch/order-sch.module": [
		889,
		22
	],
	"../pages/orderlist/orderlist.module": [
		890,
		21
	],
	"../pages/place-order/place-order.module": [
		891,
		41
	],
	"../pages/recharge/recharge.module": [
		892,
		20
	],
	"../pages/register/register.module": [
		893,
		16
	],
	"../pages/sch/sch.module": [
		894,
		19
	],
	"../pages/select-passenger/select-passenger.module": [
		895,
		40
	],
	"../pages/sendgoods-fillin/sendgoods-fillin.module": [
		896,
		39
	],
	"../pages/sendgoods-order-detail/sendgoods-order-detail.module": [
		897,
		38
	],
	"../pages/sendgoods-order-list/sendgoods-order-list.module": [
		898,
		37
	],
	"../pages/tabs/tabs.module": [
		899,
		36
	],
	"../pages/tourism-detail-images/tourism-detail-images.module": [
		900,
		5
	],
	"../pages/tourism-detail/tourism-detail.module": [
		901,
		4
	],
	"../pages/tourism-feature-detail/tourism-feature-detail.module": [
		902,
		35
	],
	"../pages/tourism-order-detail/tourism-order-detail.module": [
		903,
		18
	],
	"../pages/tourism-order-list/tourism-order-list.module": [
		904,
		34
	],
	"../pages/tourism-order-prepare/tourism-order-prepare.module": [
		905,
		33
	],
	"../pages/tourism-place-order/tourism-place-order.module": [
		906,
		1
	],
	"../pages/tourism-pyramidsell-customer/tourism-pyramidsell-customer.module": [
		907,
		10
	],
	"../pages/tourism-pyramidsell-order/tourism-pyramidsell-order.module": [
		909,
		9
	],
	"../pages/tourism-pyramidsell-shops/tourism-pyramidsell-shops.module": [
		908,
		3
	],
	"../pages/tourism-pyramidsell-start/tourism-pyramidsell-start.module": [
		910,
		32
	],
	"../pages/tourism-pyramidsell-tixian/tourism-pyramidsell-tixian.module": [
		911,
		8
	],
	"../pages/tourism-pyramidsell/tourism-pyramidsell.module": [
		912,
		31
	],
	"../pages/tourism-select-passenger/tourism-select-passenger.module": [
		913,
		30
	],
	"../pages/update-password/update-password.module": [
		914,
		29
	],
	"../pages/update-phone/update-phone.module": [
		915,
		15
	],
	"../pages/user-center/user-center.module": [
		916,
		28
	],
	"../pages/user-coupon-list/user-coupon-list.module": [
		917,
		27
	],
	"../pages/user/user.module": [
		918,
		26
	],
	"../pages/version-info/version-info.module": [
		919,
		25
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 219;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 219
// module chunks = 72